import { AccountpayableAccountType } from "../../../../../../assets/data/projectData";
import { Button, FormFieldSet, Modal, useFormHandler } from "../../../../../../components";




const InvoicedetailsModal = ({ open, onClose, rowData }) => {

  const { formData, errors, handleChange, validateAllFields } = useFormHandler({
    AccountType: "",
    tax: '',
  });



  return (
    <Modal isOpen={open} onClose={onClose} title=" Invoice details" width="max-w-4xl">

      <div className="flex items-center gap-2 ">
        <label className="text-md font-medium mt-6 mr-4" >Tax</label>
        <FormFieldSet
          type="checkbox"
          size="md"
          title=""
          options={[
            {
              label: "",
              value: true,
            },
          ]}
          values={formData.tax || []}
          onChange={(value) => handleChange("tax", value)}
          multiple
          error={errors.tax}
        />
      </div>
      <div className="grid grid-cols-2  gap-x-10 gap-y-6 mt-4 ">
        <FormFieldSet
          type="select"
          title="Account Type"
          placeholder=" select Account Type"
          value={formData.AccountType}
          onChange={(value) => handleChange("AccountType", value)}
          error={errors.AccountType}
         options={AccountpayableAccountType}
        />
      </div>
      <div className="flex gap-3 justify-end my-6">
        <Button title="Cancel" variant="outlined" onClick={""} />
        <Button title="Save" onClick={""} />
      </div>
    </Modal>
  );
};

export default InvoicedetailsModal;
